<!-- Avatar Notification Modal -->
<ion-modal
  #avatarModal
  id="avatar-notification-modal"
  [backdropDismiss]="false"
  [breakpoints]="[0, 1]"
  [handle]="false"
  [initialBreakpoint]="1"
  [isOpen]="isOpen()"
  (didDismiss)="onDidDismissModal()"
  (didPresent)="onDidPresentModal()"
>
  <ng-template>
    <div class="avatar-modal-content">
      <!-- Close Button -->
      <div class="avatar-modal-content__close">
        <ion-button fill="clear" slot="icon-only" (click)="handleCloseButton()">
          <ion-icon name="chevron-down-outline"></ion-icon>
        </ion-button>
      </div>

      <!-- Avatar Scan Image -->
      <div class="avatar-modal-content__image">
        <img alt="Avatar Scan Illustration" [src]="getAvatarImage()" />
      </div>

      <!-- Title -->
      <h1 class="avatar-modal-content__title">
        Begin Your Avatar Scan with Asa Illumination
      </h1>

      <!-- Powered By -->
      <div class="avatar-modal-content__powered">
        <div class="powered-dot"></div>
        <span class="powered-text">Powered by Asa Illumination</span>
        <ion-icon
          name="information-circle-outline"
          (click)="disclaimer.set(true)"
        ></ion-icon>
      </div>

      <!-- Description -->
      <p class="avatar-modal-content__description">
        Create your digital twin a personalized virtual avatar powered by AsaX
        designed to represent your unique identity and enhance your digital
        experience.
      </p>

      <!-- Primary CTA -->
      <div class="avatar-modal-content__buttons">
        <ion-button
          color="main-button"
          shape="round"
          (click)="handleLetGetStarted(); avatarModal.dismiss()"
        >
          Let's get started!
        </ion-button>

        <!-- Secondary CTA -->
        <button
          class="text-button"
          (click)="handleRemindLater(); avatarModal.dismiss()"
        >
          I will do it later
        </button>
      </div>
    </div>
  </ng-template>
</ion-modal>

<!-- Confirmation Dialog -->
<ion-modal
  #confirmModal
  id="avatar-confirmation-modal"
  [breakpoints]="[0, 1]"
  [handle]="false"
  [initialBreakpoint]="1"
  [isOpen]="showConfirmation()"
>
  <ng-template>
    <div class="confirmation-content">
      <!-- Chevron Icon -->
      <div class="confirmation-content__chevron">
        <ion-button
          fill="clear"
          slot="icon-only"
          (click)="handleCancelConfirmation()"
        >
          <ion-icon name="chevron-down-outline"></ion-icon>
        </ion-button>
      </div>

      <!-- Title -->
      <h2 class="confirmation-content__title">Skip Avatar Scan</h2>

      <!-- Description -->
      <p class="confirmation-content__description">
        Are you sure you want to skip this avatar scan?
      </p>

      <!-- Buttons -->
      <div class="confirmation-content__buttons">
        <ion-button
          class="later-button"
          expand="block"
          fill="outline"
          shape="round"
          (click)="handleCloseLater(); confirmModal.dismiss()"
        >
          I will do it later
        </ion-button>

        <ion-button
          class="skip-button"
          color="main-button"
          expand="block"
          shape="round"
          (click)="handleCloseSkip(); confirmModal.dismiss()"
        >
          Skip
        </ion-button>
      </div>
    </div>
  </ng-template>
</ion-modal>

<app-health-score-disclaimer [(show)]="disclaimer" />
